import { z } from 'zod'
import { type ToolUseData } from '../../../models/StreamingAIAgent'

const editDocumentSummaryToolInputSchema = z.object({
  summary: z.string(),
})

export type EditDocumentSummaryToolInput = z.infer<typeof editDocumentSummaryToolInputSchema>

export const getEditDocumentSummaryToolInput = (toolUse: ToolUseData): EditDocumentSummaryToolInput | null => {
  if (toolUse.name !== 'edit_document_summary') {
    return null
  }

  const result = editDocumentSummaryToolInputSchema.safeParse(toolUse.input)
  return result.success ? result.data : null
}
